import {useEffect, useState} from "react";
import {doc, onSnapshot} from 'firebase/firestore'
import {fire} from "../../fire";
import {ad_user_usuario} from "../../Servicios/Auth/Adaptadores/ad_user_usuario";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import logo from '../../Recursos/logo_redondo.svg'
import {funSalir} from "../../Servicios/Auth/funSalir";


export const useEscucharUsuarioToCorreoTeam = ({correo = null, funcionNoExiste = null, user}) => {
    const [usuario, setUsuario] = useState(null)
    const [verificando, setVerificando] = useState(false)
    const {Cargador, Avisos, iniciarCarga, nuevoAviso, terminar, cerrarCarga} = useCargador({logoRedondo: logo})


    useEffect(() => {

        if (correo !== null) {

            iniciarCarga('verificando cuenta')
            setVerificando(true)
            let id = getID(correo);
            onSnapshot(doc(fire, "cuentas", id), (snap) => {
                if (snap.data() && snap.data().estado === 'Aceptado') {

                    let usuario = ad_user_usuario({user: user, usuario: snap.data()})
                    cerrarCarga()
                    setUsuario(usuario)
                    setVerificando(false)


                } else {
                    if (funcionNoExiste !== null) {
                        funcionNoExiste()
                    }
                    terminar({
                        aviso: 'No cuentas con el acceso desde la cuenta seleccionada, registrate o intenta con otra cuenta',
                        variante: 'error'
                    })
                    funSalir()
                    setUsuario(null)
                    setVerificando(false)
                }
            })

        } else {
            setUsuario(null)
            setVerificando(false)
        }


    }, [correo])

    return {
        usuario,
        verificando,
        Cargador,
        Avisos
    }

}


export const getID = (email) => {
    let em = email.replaceAll("@", "_");
    return em.replaceAll(".", "-").toLocaleLowerCase();
}